import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Periodico from "../../../images/modulo14/periodico.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad3Actividad6.mp3";

const Actividad4 = () => {
  const infoUnidad = modulo14.content[2];
  const infoAct = modulo14.content[2].activities[7];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo14.content[2].name}: ${modulo14.content[2].activities[8].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[8].path}`,
    titlePrev: `${modulo14.content[2].name}: ${modulo14.content[2].activities[6].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[6].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-md-4">
          <ul>
            <li>
              Lee la siguiente noticia publicada en un diario en el año 2009. Tu
              profesor, profesora o familiar te ayudará con las palabras que no
              comprendas.
            </li>
            <li>
              Luego conversa con un compañero, compañera o familiar: ¿qué
              problema nos narra la noticia?, ¿creen que se trata de un caso de
              discriminación lingüística? , ¿por qué?
            </li>
          </ul>
        </div>
        <div className="col-md-8">
          <img src={Periodico} className="img-fluid" alt="Periodico" />
          <div className="img-capture">
            <p>
              <small>
                (Adaptado de Diario El Comercio, edición del 23 de abril de
                2009)
              </small>
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación. Lea en voz alta la noticia. Pregunte qué
            palabras no entienden y aclárelas. Pida que lean una vez la noticia.
          </li>
          <li>
            Lea la siguiente indicación: Luego conversa con un compañero,
            compañera o familiar: ¿qué problema nos narra la noticia?, ¿creen
            que se trata de un caso de discriminación lingüística? , ¿por qué?
            Pida que den oralmente, en voz alta, sus
            respuestas a cada una de las preguntas. Comente sus respuestas. Por
            ejemplo:
            <ul>
              <li>
                <i>
                  “En la noticia se narra que el periódico Correo publicó lo que
                  la congresista Hilaria Supa había escrito en un cuaderno de
                  apuntes. El periódico criticó los errores ortográficos
                  cometidos por la congresista”.
                </i>
              </li>
              <li>
                <i>
                  “Evidentemente se trata de un caso de discriminación
                  lingüística. No se puede juzgar a la congresista por su
                  escritura. Hacerlo implica reforzar el estereotipo que
                  considera que los quechuahablantes son ignorantes”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
